export const range = (start: number, length: number) =>
  Array.from({ length }, (_, index) => index + start);

export const getNumbers = (current: number, total: number) => {
  if (current === 1 || current === 2 || current === 3 || total < 6) {
    return range(1, Math.min(5, total)).map((number) => ({
      value: number,
      display: "flex",
    }));
  }

  let numbers: number[];
  if (total === current || total === current + 1) {
    numbers = range(total - 4, 5);
  } else {
    numbers = range(current - 2, 5);
  }

  return numbers.map((number, index) => ({
    value: number,
    display: index > 1 ? "flex" : ["none", "flex"],
  }));
};
